type Brand = {
  name: string
  email: string
  tagline: string
  description: string
  website: string
  logoImage: string
  logoImageBlack: string
}

const MEMOWRITE: Brand = {
  name: 'Memowrite',
  email: 'hello@getmemowrite.com',
  tagline: 'Easily turn your life story into a book',
  description:
    'Memowrite is an easy-to-use platform designed to help individuals capture their personal or family stories and turn them into beautiful, professionally crafted memoirs',
  website: 'memowrite.com',
  logoImage: '/images/memowrite-logo.png',
  logoImageBlack: '/images/memowrite-logo-black.png',
}

const WRITEYOURLOVE: Brand = {
  name: 'WriteYourLove',
  email: 'hello@writeyourlove.com',
  tagline: 'Easily turn your life story into a book',
  description:
    'WriteYourLove is an easy-to-use platform designed to help individuals capture their personal or family stories and turn them into beautiful, professionally crafted memoirs',
  website: 'writeyourlove.com',
  logoImage: '/images/writeyourlove-logo.png',
  logoImageBlack: '/images/writeyourlove-logo-black.png',
}

const HOLYWRITE: Brand = {
  name: 'HolyWrite',
  email: 'hello@holywrite.com',
  tagline: 'Easily turn your life story into a book',
  description:
    'HolyWrite is an easy-to-use platform designed to help individuals capture their personal or family stories and turn them into beautiful, professionally crafted memoirs',
  website: 'holywrite.com',
  logoImage: '/images/holywrite-logo.png',
  logoImageBlack: '/images/holywrite-logo-black.png',
}

const SANDBOX_HOST = 'growth-px-frontend-mw-product-sandbox.cl2.kilo.live'

const BRAND_CONFIG = [
  {
    brand: MEMOWRITE,
    hosts: ['localhost:3001', SANDBOX_HOST, 'app.memowrite.com'],
    prodDomains: ['memowrite.com', 'www.memowrite.com'],
  },
  {
    brand: WRITEYOURLOVE,
    hosts: ['localhost:3004', SANDBOX_HOST, 'app.writeyourlove.com'],
    prodDomains: ['writeyourlove.com', 'www.writeyourlove.com'],
  },
  {
    brand: HOLYWRITE,
    hosts: ['localhost:3005', SANDBOX_HOST, 'app.holywrite.com'],
    prodDomains: ['holywrite.com', 'www.holywrite.com'],
  },
]

const getBrandByProdDomain = (prodDomain: string | null): Brand | null => {
  if (!prodDomain) return null
  const normalized = prodDomain.trim().toLowerCase()
  const match = BRAND_CONFIG.find((c) => c.prodDomains.some((d) => d === normalized))
  return match?.brand ?? null
}

export const getBrandFromHost = (host: string): Brand => {
  const match = BRAND_CONFIG.find((c) => c.hosts.some((h) => host.includes(h)))
  return match?.brand ?? MEMOWRITE
}

export const getBrand = (): Brand => {
  if (typeof window === 'undefined') return MEMOWRITE
  const host = window.location.host
  if (host.includes(SANDBOX_HOST)) {
    const prodDomain = new URLSearchParams(window.location.search).get('prod-domain')
    const brandFromQuery = getBrandByProdDomain(prodDomain)
    if (brandFromQuery) return brandFromQuery
  }
  return getBrandFromHost(host)
}

export const getApiUrl = (): string => process.env.NEXT_PUBLIC_API_URL
